<template>
  <v-dialog
    v-model="dialog"
    max-width="450"
    content-class="dialog-plan-obiettivo"
    :retain-focus="false"
  >
    <v-card class="navy dialog-plan-obiettivo-card">
      <div class="secondary white--text d-flex align-center font-hemi-head pa-4">
        <span style="font-size: 16px">Aggiungi obiettivo slot</span>
        <v-spacer></v-spacer>
        <v-btn depressed icon @click="dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <div class="text--text text--lighten-2 pa-2">
        Seleziona uno o più svincolati da tenere come obiettivi per questo slot.
        Un calciatore "obiettivo" é un calciatore che vorresti acquistare in questo slot
      </div>

      <asta-svincolati
        :key="pickerKey"
        class="dialog-plan-obiettivo-svincolati"
        :selected="addObiettivo"
        :ruoliAllowed="[ruolo_id]"
        :dialogParent="dialog"
        :showInformazioni="false"
        :showStats="true"
        :smallCalciatori="true"
        :showButtonScartati="false"
        :visuallyDisabledCalciatoriIds="obiettiviIds"
        pickerMode
        forceClassic
        ripple
      ></asta-svincolati>
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from "../../js/constants";
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import Vuex from "vuex";
import db from "../../js/db";
import AstaSvincolati from "../AstaSvincolati";

export default {
  name: "dialog-plan-obiettivo",
  mixins: [mixins, toast],
  components: { AstaSvincolati },
  mounted() {
    console.log("--> DialogPlanObiettivo mounted.");
    db.on("DialogPlanObiettivo", this.show);
  },
  destroyed() {
    console.log("<-- DialogPlanObiettivo destroyed.");
    db.off("DialogPlanObiettivo", this.show);
  },
  data() {
    return {
      dialog: false,
      ruolo_abc: "P",
      iSlot: null,
      processing: false,
    };
  },
  methods: {
    show(ruolo_abc, iSlot) {
      this.ruolo_abc = ruolo_abc;
      this.iSlot = iSlot;
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
      this.iSlot = null;
    },
    addObiettivo(calciatore_id) {
      if (this.processing || !this.iSlot) {
        return;
      }
      const slot = (this.myPlan[this.ruolo_abc] || {})[this.iSlot];
      if (!slot || slot.associato) {
        this.errorToast("Slot non disponibile", "Scegli uno slot libero nella pianificazione.");
        this.dismiss();
        return;
      }

      const obiettivi = this.obiettiviIds;
      if (obiettivi.includes(calciatore_id)) {
        this.errorToast("Già presente", "Calciatore già tra gli obiettivi");
        return;
      }

      this.processing = true;
      db.updatePlan({
        [this.ruolo_abc]: {
          [this.iSlot]: {
            calciatori: Object.fromEntries(
              [...obiettivi, calciatore_id].entries()
            ),
          },
        },
      })
        .then(() => {
          this.successToast(
            "Obiettivo aggiunto",
            this.calciatori[calciatore_id]?.calciatore || ""
          );
          this.dismiss();
        })
        .catch(() => {
          this.errorToast("Errore", "Operazione non riuscita");
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
  computed: {
    ruolo_id() {
      return Constants.RUOLO[this.ruolo_abc];
    },
    pickerKey() {
      return this.ruolo_abc + "_" + this.iSlot;
    },
    obiettiviIds() {
      if (!this.iSlot || !this.myPlan[this.ruolo_abc] || !this.myPlan[this.ruolo_abc][this.iSlot]) {
        return [];
      }

      const obiettivi = this.myPlan[this.ruolo_abc][this.iSlot].calciatori || [];
      return Object.values(obiettivi);
    },
    ...Vuex.mapGetters(["myPlan", "calciatori"]),
  },
};
</script>
<style lang="scss" scoped>
.dialog-plan-obiettivo-card {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 48px);
  max-height: calc(100vh - 48px);
  overflow: hidden;
}

.dialog-plan-obiettivo-svincolati {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
</style>

<style lang="scss">
.dialog-plan-obiettivo {
  overflow: hidden;

  .dialog-plan-obiettivo-svincolati {
    > div {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      min-height: 0;
    }

    .svincolati {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      min-height: 0;
    }

    .svincolati-list {
      flex: 1 1 auto;
      min-height: 0;
    }

    .svincolati-list > div {
      height: 100%;
    }

    .svincolati-list .recycle-scroller {
      height: 100% !important;
    }
  }
}
</style>
